/*
 * @Date: 2019-12-08 17:13:38
 * @LastEditors: miaomiaodeng
 * @LastEditTime: 2020-03-11 16:52:10
 * @FilePath: /rongxin.web/src/views/home/index.js
 */
import Service from './servece.js';
// component
import Navbar from '../../../components/navbar/index.vue';
import ProductService from '../../home/product-service/index.vue';
import contactUs from '../../home/contact-us/index.vue';
import Pagination from '@/components/pagination/index.vue';
export default {
  name: 'home',
  components: {
    Navbar,
    ProductService,
    contactUs,
    Pagination
  },
  data() {
    return {
      fromisActiveClass: 'newsCenter',
      color: '#fff',
      params: {
        // homePage: 1, // 只查首页推荐且已发布状态的数据
        status: 1, // 已发布状态
        limit: 6,
        pageNum: 1,
        skip: 0,
        clientId: '6188e0dbc2d92675c94f5598',
        catalogId: '6188e618c2d92675c94f559a',
        source: 'guanWang'
      },
      newsArr: [],
      total: 0
    };
  },
  created() {
    window.scrollTo(0, 0);
    this.getNewsList();
  },
  methods: {
    getNewsList(Pagination = {}) {
      console.log(Pagination);
      if(Pagination.pageNo || Pagination.pageSize) {
        this.params.pageNum = Pagination.pageNo;
        this.params.limit = Pagination.pageSize;
      }
      let query = {
        ...this.params,
        skip: this.params.pageNum ?  (this.params.pageNum - 1) * this.params.limit : 0
      };
      Service.getNewsList(query).then(data => {
        this.newsArr = data.data && data.data.list;
        this.total = data.data.total;
      });
    },
    goHome(paths) {
      this.$router.push({path: paths});
    },
    goDetailNews(paths, id, guanWang) {
      this.$router.push({
        path: paths,
        query: {
          id: id,
          guanWang
        }
      });
    }
  }
};
